@if (summary()) {
    <div class="mt-3 card">
        <div class="card-body">
            <div
                (click)="toggleExpand()"
                class="clickable d-flex justify-content-between"
            >
                <div class="main-blue font-weight-bold">
                    {{ "SellCampCoupon.Title" | translate }}
                </div>
                @if (isExpanded()) {
                    <img src="assets/chevron_up.svg" />
                }
                @if (!isExpanded()) {
                    <img src="assets/chevron_down.svg" />
                }
            </div>
            @if (isExpanded()) {
                <div
                    class="d-flex justify-content-between align-items-center mt-2"
                >
                    <input
                        class="form-control mr-2"
                        type="text"
                        placeholder="Enter coupon code"
                        [(ngModel)]="couponCode"
                        [readOnly]="couponAppliedSuccessfully()"
                    />
                    @if (!couponAppliedSuccessfully()) {
                        <button
                            class="btn btn-outline-success"
                            [disabled]="!couponCode"
                            (click)="applyCoupon()"
                        >
                            {{ "SellCampCoupon.Apply" | translate }}
                        </button>
                    }
                    @if (couponAppliedSuccessfully()) {
                        <button
                            class="btn btn-outline-danger"
                            (click)="removeCoupon()"
                        >
                            {{ "SellCampCoupon.Remove" | translate }}
                        </button>
                    }
                </div>
                @if (couponAppliedSuccessfully()) {
                    <div class="main-grey mt-1 d-flex align-items-center">
                        <img class="mr-2" src="assets/icon_ok.svg" />
                        <span>{{ "SellCampCoupon.Applied" | translate }}</span>
                    </div>
                }
            }
        </div>
    </div>
}
